import React from 'react'
import {Button, Col, Container, Form, Image, NavDropdown, Row} from "react-bootstrap";
import fullLogin from './images/fullLogin.jpg'
import {Globe} from 'react-bootstrap-icons';
import {TFunction} from "i18next";
import {AlertItem} from "../../components/alert_item/AlertItem";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'

interface SignInProps {
    onClickLanguage(lang: string)

    onChangePhoneNumber(phoneNumber: string),

    onChangePassword(password: string),

    onClickSignIn(),

    onCloseAlert(),

    showAlert: boolean,
    alertText: string,
    phoneNumber: string,
    password: string,

    t: TFunction
}


export const SignIn = ({phoneNumber, password, showAlert, alertText, onCloseAlert, onChangePassword, onChangePhoneNumber, onClickLanguage, onClickSignIn, t}: SignInProps) =>
    <div style={{height: '100vh', width: '100vw', backgroundColor: '#e30171', color: '#e30171'}}>
        <Container>
            <Row style={{height: '40px', width: '100%'}}/>
            <AlertItem alertHeader={"Wystąpił błąd"} alertText={alertText} isVisible={showAlert}
                       onClickClose={onCloseAlert}/>
            <Row style={{backgroundColor: 'white'}}>
                <Col xs={12} lg={8}>
                    <Image style={{width: '100%', padding: 0}} src={fullLogin}/>
                </Col>

                <Col style={{marginTop: '20px'}}>
                    <Row>
                        <NavDropdown style={{paddingRight: '15px'}}
                                     title={<React.Fragment>
                                         <span style={{paddingRight: '10px', color: '#e30171'}}><Globe/></span><span
                                         style={{color: '#e30171'}}>{t('menu.languages')}</span></React.Fragment>}
                                     id="collasible-nav-dropdown">


                            <NavDropdown.Item
                                onClick={() => onClickLanguage('pl')}>{t('menu.polish')}</NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() => onClickLanguage('en')}>{t('menu.english')}</NavDropdown.Item>
                        </NavDropdown>
                    </Row>
                    <Row>
                        <h2>{t('form.header')}</h2>
                    </Row>
                    <Row>
                        <Form>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>{t('form.phoneNumber')}</Form.Label>

                                <PhoneInput inputStyle={{width: '100%'}}
                                            country={'pl'}
                                            value={phoneNumber}
                                            onChange={(phone) => onChangePhoneNumber(phone)}
                                />

                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>{t('form.messageId')}</Form.Label>
                                <Form.Control type="password" value={password}
                                              onChange={e => onChangePassword(e.target.value)}
                                />
                            </Form.Group>
                            <Col md={{span: 4, offset: 4}} xs={{span: 4, offset: 4}}>
                                <Button style={{backgroundColor: '#e30171', width: '100%', marginBottom: '25px'}}
                                        variant="primary" onClick={onClickSignIn}>{t('form.signin')}</Button>
                            </Col>
                        </Form>


                    </Row>
                </Col>
            </Row>
        </Container>
    </div>;